var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 15.4001L16.7993 12.0001C16.5686 11.827 16.2878 11.7334 15.9993 11.7334C15.7109 11.7334 15.4301 11.827 15.1993 12.0001L10.666 15.4001M18.666 18.7334L15.9993 16.7334L13.3327 18.7334",
    stroke: "#0E2C66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.8897C4 9.62566 4 7.49366 4.504 6.77632C5.00667 6.06033 7.01067 5.37366 11.02 4.00166L11.784 3.74033C13.8733 3.02433 14.9173 2.66699 16 2.66699C17.0813 2.66699 18.1267 3.02433 20.216 3.74033L20.98 4.00166C24.9893 5.37366 26.9933 6.06033 27.496 6.77632C28 7.49366 28 9.62699 28 13.8897V15.9883C28 19.3283 26.884 21.9043 25.3333 23.8723M4.25733 18.667C5.4 24.3977 10.1013 27.351 13.1987 28.703C14.16 29.123 14.6413 29.3337 16 29.3337C17.36 29.3337 17.84 29.123 18.8013 28.703C19.5733 28.367 20.4427 27.9297 21.3333 27.3777",
    stroke: "#0E2C66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.3614703156d43aa7d481357b898354ce.svg";
export { ForwardRef as ReactComponent };